import { styled } from "@mui/material";

const AnswerWrapper = styled("div")({
  alignSelf: "flex-end",
  backgroundColor: "#DBEEF4",
  padding: "10px",
  margin: "5px 10px",
  borderRadius: "1rem",
  maxWidth: "75%",
});

const ChatbotAnswerUnstyled = ({ text, className }) => {
  return (
    <AnswerWrapper className={className}>
      <p>{text}</p>
    </AnswerWrapper>
  );
};

const ChatbotAnswer = styled(ChatbotAnswerUnstyled)({});

export default ChatbotAnswer;
